import tw, { styled } from 'twin.macro';
import { variants } from '@/components/Link/Link.styles';

export const StyledEventsWrapper = styled.div`
  ${tw`relative`}
`;

export const StyledEventsSection = styled.div`
  ${tw`relative`}
`;

export const StyledEventsButton = styled.button`
  ${variants.nav_text_link}
  ${tw`min-h-[62px]`}
  & img {
    ${tw`max-w-[unset] max-h-[unset] w-[20px] h-[20px]`}
  }
`;

export const StyledBadge = styled.div`
  ${tw`absolute top-[12px] right-[-10px]`}
  ${tw`px-[3px] pl-[3px] pr-[2px]`}
  ${tw`inline-flex items-center justify-center`}
  ${tw`min-w-[18px] min-h-[18px]`}
  ${tw`rounded-full`}
  ${tw`font-inter font-semi-bold`}
  ${tw`text-tag-s text-neutrals-n1`}
  ${tw`bg-tertiary-t2`}
`;

export const StyledMobileHeader = styled.div`
  ${tw`lg:hidden`}
  ${tw`py-[20px] px-[21px]`}
  ${tw`flex justify-end`}
  ${tw`border-b-2 border-primary-p1`}
`;

export const StyledMenu = styled.div<{ isActive: boolean }>`
  ${tw`fixed lg:absolute`}
  ${tw`top-0 left-0 lg:top-[78px] lg:left-auto lg:right-[-50px]`}
  ${tw`bg-neutrals-n1`}
  ${tw`w-full h-0 lg:w-max lg:max-w-[393px] lg:max-h-[calc(100vh - 150px)]`}
  ${tw`z-[100] lg:z-30`}
  ${tw`rounded-xl`}
  ${tw`overflow-y-auto`}
  ${tw`text-left`}
  ${tw`transition-[height] lg:transition-opacity duration-300 ease-in-out`}

  ${tw`opacity-0`}
  ${tw`lg:transition-opacity lg:duration-[0.3s]`}

  ${({ isActive }) =>
    isActive && [
      tw`lg:border-2 border-primary-p1`,
      tw`opacity-100`,
      tw`h-[100vh] lg:h-auto`,
      tw`lg:py-[20px] lg:pl-[12px] lg:pr-[20px]`,
    ]}
`;

export const StyledContents = styled.div`
  ${tw`px-[12px] lg:pb-1 lg:pt-0 py-1`}
  ${tw`lg:rounded-xl`}
`;

export const StyledTitle = styled.h2`
  ${tw`p-1`}
  ${tw`font-poppins lg:font-inter font-semi-bold `}
  ${tw`text-tag-l lg:text-[14px] lg:leading-[18px]`}
  ${tw`text-primary-p1 lg:text-secondary-s1`}

  & div {
    ${tw`pb-[9px] lg:pb-0`}
    ${tw`border-b border-neutrals-n7 lg:border-none `}
  }
`;

export const StyledLink = styled.a`
  ${tw`px-1 py-[4px]`}
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-tag-l text-primary-p1`}
  ${tw`tracking-normal`}
`;

export const StyledEventLinks = styled.div`
  & a {
    ${tw`bg-[rgb(238 244 252 / 0)]`}
    ${tw`transition-colors duration-300 ease-out`}
    ${tw`rounded`}
  }

  & a:hover {
    ${tw`bg-ui-colours-ui1`}
  }

  & a:not(:last-of-type) {
    ${tw`mb-[12px]`}
  }

  & a:last-of-type {
    ${tw`mb-2`}
  }
`;
